import React from "react"
import { HeaderComponent } from "../common/header"
import { DEFAULTGAP, VERSIONDESCRIPTION } from "../../globals"

export const HomeComponent = () => {
  return <HeaderComponent
  props={{
    style: {
      paddingInline: DEFAULTGAP
    }
  }}
  title={VERSIONDESCRIPTION}
/>
} 